import api from "./api";

const MENSAGEM_ERRO_PADRAO = {
  listar: "Erro ao listar representados.",
  obter: "Erro ao obter representado.",
  criar: "Erro ao cadastrar representado.",
  atualizar: "Erro ao atualizar representado.",
  excluir: "Erro ao excluir representado.",
};

function lancarErroDaApi(error, mensagemPadrao) {
  if (error.response?.data) {
    throw error.response.data;
  }
  throw new Error(mensagemPadrao);
}

const representadoService = {
  listar: async () => {
    try {
      const response = await api.get("Representado");
      const itens = response.data?.items ?? response.data?.data ?? response.data;
      return Array.isArray(itens) ? itens : [];
    } catch (error) {
      return lancarErroDaApi(error, MENSAGEM_ERRO_PADRAO.listar);
    }
  },

  obter: async (id) => {
    try {
      const response = await api.get(`Representado/${id}`);
      return response.data?.data ?? response.data;
    } catch (error) {
      return lancarErroDaApi(error, MENSAGEM_ERRO_PADRAO.obter);
    }
  },

  criar: async (dados) => {
    try {
      const response = await api.post("Representado", dados);
      return response.data?.data ?? response.data;
    } catch (error) {
      return lancarErroDaApi(error, MENSAGEM_ERRO_PADRAO.criar);
    }
  },

  atualizar: async (id, dados) => {
    try {
      const response = await api.put(`Representado/${id}`, dados);
      return response.data;
    } catch (error) {
      return lancarErroDaApi(error, MENSAGEM_ERRO_PADRAO.atualizar);
    }
  },

  excluir: async (id) => {
    try {
      const response = await api.delete(`Representado/${id}`);
      return response.data;
    } catch (error) {
      return lancarErroDaApi(error, MENSAGEM_ERRO_PADRAO.excluir);
    }
  },
};

export default representadoService;
